//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';
import { BackgroundImageSection } from '@/containers-m/BackgroundImageSection';

//data
import { contactOptions } from '@/vendor/HubspotFormIntegration';

// context containers
import { Hero, Office, NeedAssistance, GetInTouch } from './containers';

//styles
import { PageWrapper, ContactGlobalStyle } from './Contact.styles';

const Contact = ({
  hero_content,
  office_content,
  needAssistance_content,
  getInTouch_content,
  backgroundImageSection_content,
  nav,
  footer,
}) => {
  return (
    <PageWrapper>
      <ContactGlobalStyle />
      <Navigation theme="dark" nav={nav} />
      <Hero content={hero_content} />
      <Office content={office_content} />
      {needAssistance_content && (
        <NeedAssistance content={needAssistance_content} />
      )}
      <div id="contact-form">
        <GetInTouch
          title={getInTouch_content.title}
          subtitle={getInTouch_content.subtitle}
          {...contactOptions}
          disclaimer={true}
          disclaimerHtml={getInTouch_content.smsDisclosureHtml}
        />
      </div>
      <BackgroundImageSection content={backgroundImageSection_content} />
      <Footer config={footer} />
    </PageWrapper>
  );
};

export default Contact;
export { Contact };
